package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.trades.TradesClosingSection
import com.anjuros.website.redesign.sections.trades.TradesDirectorySection
import com.anjuros.website.redesign.sections.trades.TradesFaqSection
import com.anjuros.website.redesign.sections.trades.TradesHeroSection
import com.anjuros.website.redesign.sections.trades.TradesNeedsSection
import com.anjuros.website.redesign.sections.trades.tradesStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun WebsiteDesignForUkTrades() {
    val title = LocalText(RdText.TRADES_META_TITLE)
    val description = LocalText(RdText.TRADES_META_DESCRIPTION)
    val structuredData = tradesStructuredData()
    // Shared by the hero's search box and the directory it filters.
    var query by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.TRADES}")
        setJsonLd("ld-trades", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.TRADES))
        Main {
            TradesHeroSection(query, onQueryChange = { query = it })
            TradesDirectorySection(query)
            TradesNeedsSection()
            TradesFaqSection()
            TradesClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
